const BACKEND = process.env.REACT_APP_BACKEND_URL;
const absUrl = (u) => (!u ? "" : u.startsWith("http") ? u : `${BACKEND}${u}`);
const initialsOf = (s) => (s || "").split(" ").map((x) => x[0]).join("").slice(0, 2).toUpperCase();

export const AgentContact = ({ profile, name }) => {
  const p = profile || {};
  const label = p.name || name || "—";
  const initials = initialsOf(p.name || name);
  return (
    <div className="flex items-center gap-2.5" data-testid="agent-contact">
      {p.headshot ? (
        <img src={absUrl(p.headshot)} alt={label} className="w-8 h-8 rounded-full object-cover shrink-0" />
      ) : (
        <div className="w-8 h-8 rounded-full bg-[#EAF0FB] text-[#1F3C88] flex items-center justify-center text-[10px] font-semibold shrink-0">{initials || "—"}</div>
      )}
      <div className="min-w-0">
        <div className="font-medium text-[#0A0A0A] truncate">{label}</div>
        {p.phone ? (
          <a href={`tel:${p.phone}`} onClick={(e) => e.stopPropagation()} data-testid="agent-phone" className="text-xs text-[#F7941D] hover:underline">{p.phone}</a>
        ) : (
          <span className="text-xs text-[#a3a099]">No phone on file</span>
        )}
      </div>
    </div>
  );
};
